export enum TypeType {
  DefaultType,
  FunctionType,
}
